import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from './Home';
import MultiPlayer from './MultiPlayer';
import SinglePlayer from './SinglePlayer';
import MultiPlayerGame from './MultiPlayerGame';
import SinglePlayerGame from './SinglePlayerGame';


export default function Main() {
    return (
        <div className="Main">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path='/play/multi-player-game' element={<MultiPlayer />} />
                <Route path='/play/single-player-game' element={<SinglePlayer />} />
                <Route path='/play/multi-player-game/:id' element={<MultiPlayerGame />} />
                <Route path='/play/single-player-game/:id' element={<SinglePlayerGame />} />
            </Routes>
        </div>
    )
}